import { Path } from 'enums';
import AccountModule from 'modules/account/account.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const AccountPage = () => {
  return (
    <Switch>
      <Route exact path={Path.Account} component={AccountModule} />
    </Switch>
  );
};

export default AccountPage;
